import { useFormContext } from "react-hook-form";
import { FormControl, Input, InputLabel } from "@mui/material";

const Index = (props: any) => {
  const { register } = useFormContext();
  return (
    <FormControl fullWidth>
      <InputLabel htmlFor={props.nazivPolja}>Poštanski broj (Postal code)</InputLabel>
      <Input
        aria-describedby="postanski broj"
        {...register(props.nazivPolja)}
      />
    </FormControl>
  );
};

export default Index;
